var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "item-wrapper"
  }, [_c('a', {
    attrs: {
      "href": _vm.item.url
    }
  }, [_vm.image ? _c('img', {
    attrs: {
      "src": _vm.image,
      "alt": _vm.item.name
    }
  }) : _vm._e(), _c('div', {
    staticClass: "item-info"
  }, [_c('h5', {
    staticClass: "item-name"
  }, [_vm._v(" " + _vm._s(_vm.item.name))]), _c('p', {
    staticClass: "item-description",
    domProps: {
      "innerHTML": _vm._s(_vm.item.description)
    }
  }), _c('time', {
    staticClass: "item-date"
  }, [_vm._v(" " + _vm._s(_vm.item.date))])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }